export default __webpack_public_path__ + "static/media/bloom-logo-text.3588d744.png";